/** Take in an input and a max. If input is higher than max, return the max. */
export function getValueCeiling(input = 0, max = 0) {
  if (input >= max) {
    return max;
  }
  return input;
}



// WEBPACK FOOTER //
// ./src/helpers/get-value-ceiling.js